import { AfterViewInit, Component } from '@angular/core';
import { LoaderService } from '../../core/service/loader/loader.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TicketService } from 'src/app/core/service/tickets/tickets.service';
import { ApiResponseStatus } from 'src/app/core/models/common/enums/api-response-status.enum';
import ErrorResponse from 'src/app/core/models/common/error-response.model';
import { NotificationService } from 'src/app/core/service/notifications/notification.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements AfterViewInit {

  contactUsForm: FormGroup = new FormGroup({
    yourEmail: new FormControl('', { validators: [Validators.required, Validators.email] }),
    yourName: new FormControl('', { validators: [Validators.required] }),
    yourMessage: new FormControl('', { validators: [Validators.required] }),

  });

  constructor(private loaderService: LoaderService, private ticketService: TicketService, private notificationService: NotificationService) { }

  ngAfterViewInit(): void {
    this.loaderService.showLoader();
    if (window.particlesJS) {
      window.particlesJS('tsparticles1', {
        particles: {
          number: { value: 100 },
          color: { value: '#fff' },
          line_linked: { enable: true, color: '#fff' },
          move: { enable: true, speed: 6 }
        }
      });

      setTimeout(() => {
        this.loaderService.hideLoader();
      }, 1000);
    }
  }

  submitMessage(): void {
    const { yourName, yourEmail, yourMessage } = this.contactUsForm.value;

    this.loaderService.showLoader();
    this.ticketService.sendSupportRequest(yourName, yourEmail, yourMessage).subscribe(
      (response) => {
        this.loaderService.hideLoader();
        if (response && response.status === ApiResponseStatus.Error) {
          const errorResponse = response.content as ErrorResponse;
          console.error(errorResponse);
          this.notificationService.showError('Operation failed');
        } else {
          this.notificationService.showSuccess('Message sended to the support');
          this.contactUsForm.reset();
        }
      }
    );
  }

}
